export enum DBLocalMenu {
    HOME = 'HOME',
    SETTINGS = 'SETTINGS',
    USERLIST = 'SETTINGSUSERLIST',
    COMPANYPROFILE = 'COMPANYPROFILE',
    ADDUSER = 'ADDUSER',
    MUTATEUSER = 'MUTATEUSER',
    MUTATECOMPANYPROFILE = 'MUTATECOMPANYPROFILE',

    QUOTE = 'QUOTE',
    NEWQUOTE = 'NEWQUOTE',
    QUOTELIST = 'QUOTELIST',

    MANAGER = 'MANAGER',
    SUPERADMIN = 'SUPERADMIN',
    REGISTRY = 'REGISTRY',
}

export enum DBLocalMenuIcon {
    HOME = 'home-line-duotone',

    SETTINGS = 'settings-line-duotone',
    USERLIST = 'users-group-two-rounded-line-duotone',
    COMPANYPROFILE = 'buildings-2-line-duotone',
    ADDUSER = 'add-user-line-duotone',
    MUTATEUSER = 'mutate-user-line-duotone',
    MUTATECOMPANYPROFILE = 'mutate-company-profile-line-duotone',
    COMPANYSETTINGS = 'buildings-2-line-duotone',
    COMPANYLIST = 'home-angle-line-duotone',

    QUOTE = 'bill-check-line-duotone',
    NEWQUOTE = 'add-square-line-duotone',
    QUOTELIST = 'bill-list-line-duotone',
    QUOTEMANAGE = 'file-text-line-duotone',


    MANAGER = 'widget-6-line-duotone',
    PRODUCTMODELLIST = 'layers-bold-duotone',
    PANTONELIST = 'palette-round-bold-duotone',
    OPTIONALLIST = 'check-square-line-duotone',
    MEASUREGROUPLIST = 'ruler-angular-line-duotone',
    SUPERADMIN = 'shield-star-line-duotone',
    REGISTRY = 'user-id-line-duotone',
    ACCESSORYLIST = 'inbox-archive-line-duotone',
    PRICELIST = 'euro-line-duotone',
}